
export enum UserAuthType {
	AUTHENTICATED = "AUTHENTICATED",
	NOTAUTHENTICATED = "NOTAUTHENTICATED",
};